import Multiselect from "@rio-cloud/rio-uikit/Multiselect";
import type { ITransactionImport, TransactionOrigin } from "@types";
import { useT } from "@hooks";

const ORIGIN_OPTIONS: TransactionOrigin[] = ["FORM", "IMPORT", "INTEGRATION"];

export interface ToolbarOriginFiltersProps {
  origins: TransactionOrigin[];
  importIds: string[];
  imports: ITransactionImport[];
  isLoadingImports?: boolean;
  onOriginsChange: (origins: TransactionOrigin[]) => void;
  onImportIdsChange: (importIds: string[]) => void;
}

const ToolbarOriginFilters = ({
  origins,
  importIds,
  imports,
  isLoadingImports = false,
  onOriginsChange,
  onImportIdsChange,
}: ToolbarOriginFiltersProps) => {
  const t = useT();

  return (
    <>
      <div className="width-100pct-xs width-200" data-testid="toolbar-origin-filter">
        <Multiselect
          className="rounded-small"
          placeholder={t("batchDelete.filter.origin")}
          options={ORIGIN_OPTIONS.map((origin) => ({ id: origin, label: t(`batchDelete.filter.origin.${origin}`) }))}
          value={origins}
          onChange={(selected) => onOriginsChange(selected as TransactionOrigin[])}
          renderCounterMessage={(amount) =>
            t("batchDelete.filter.counter", { label: t("batchDelete.filter.origin"), count: amount })
          }
        />
      </div>
      <div className="width-100pct-xs width-250" data-testid="toolbar-import-filter">
        <Multiselect
          className="rounded-small"
          placeholder={t("batchDelete.filter.importFile")}
          options={imports.map((item) => ({ id: item.importId, label: item.fileName }))}
          value={importIds}
          onChange={onImportIdsChange}
          isLoading={isLoadingImports}
          noItemMessage={t("batchDelete.filter.importFile.empty")}
          renderCounterMessage={(amount) =>
            t("batchDelete.filter.counter", { label: t("batchDelete.filter.importFile"), count: amount })
          }
        />
      </div>
    </>
  );
};

export default ToolbarOriginFilters;
